function ResponsiveTables(identifier) {
    this.identifier = identifier;
}

ResponsiveTables.prototype.makeResponsive = function() {
    jQuery(this.identifier).addClass("mobileReady").find("tr").each(function() {
        var head = jQuery(this).find("th");
        jQuery(this).find("td:first-of-type").prepend('<span class="mobile-head">'+head.text()+'</span>');
    });
};

var responsiveTables = new ResponsiveTables("main .table");
responsiveTables.makeResponsive();